<template>
    <div class="homepage d-flex flex-column vh-100">
        <!-- navbar -->
        <div class="d-flex align-items-center gap-3 p-3 bg-primary">
            <span @click="$router.go(-1)" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span>
            <div>
                <h6 class="fw-bold text-white mb-0">Go Back</h6>
                <p class="text-white-50 small m-0">To Home</p>
            </div>
        </div>
        <!--start------------------------------------------------------- body----------------------------------------------------------------------------->
        <div>
            <div class="card-header text-center mt-2">
                <h3>All Categories</h3>
            </div>
        
            <div class="card border-0 shadow-sm p-4 pt-1 bg-white rounded-4">
                <div class="card-body">
                    <div class="row  ">
                        <div class="col-6 category" v-for="(cat, i) in categories" :key="i">
                            <!-- Single Category -->
                           <router-link :to="'/list?name='+cat.name" class="link-dark">
                                <div class="card bg-transparent border-0 text-center">
                                   <img :src="'https://mh13.dktsoft.in/public/uploads/'+cat.img" alt="" class="card-img-top rounded-4 mb-2">
                                   <div class="card-body p-0">
                                      <!--<p class="card-title small m-0">{{cat.name}}</p>-->
                                   </div>
                                </div>
                             </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        


        <!-- end ---------------------------------------------------------body----------------------------------------------------------------------------->












        <!-- footer -->
        <div class="footer bg-white shadow mt-auto border-top">
            <div class="d-flex align-items-center justify-content-center py-1">
                <!--<p style="text-align: center; color: white; margin: 0;">Designed And Developed by DK Techno's</p>-->
            </div>
        </div>

    </div>
</template>

<style scoped>
    .hover-zoom {
        transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    }

    .hover-zoom:hover {
        transform: scale(1.05);
        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
    }

    .custon-design {
        text-transform: capitalize;
        background-color: bisque;
    }

    .custom-btn {
        background: linear-gradient(328deg, #ff0000, #000199);
        border: none;
        /* Remove Bootstrap's default border */
        color: white;
        /* Ensure text is readable */
    }
</style>



<script>
    import axios from "@/plugins/axios";
import {
  fetchCategories
} from  "@/plugins/apiService";

    export default {
        name: 'HomeView',
        components: {
        },
        mounted() {
            this.getHomeBasic();
        },
        data() {
            return {
                loading: false,
                error: null,
                categories: [],
                foodcategories:[],
                businesscategories:[],

             

            }
        },
    
        methods: {
           


            newregister() {

                alert("hello")


            },
            previous_food(){
                this.isFood = false;
            },



            async getHomeBasic() {
                // this.loading = true;
                this.error = null;
                 fetchCategories() .then((res) => {this.categories = res.data;}).catch(() => {this.error = "Failed to load categories.";}).finally(() => { });
          

                // try {
                //     var self = this;
                //     axios.post("getfrontview").then((response) => {
                //         self.categories = response.data.app_categories;
                //         self.foodcategories = response.data.foodcategories;
                //         self.businesscategories = response.data.businesscategories;
                //         self.events = response.data.events;
                //         self.listings = response.data.businesslisting;
                //         self.properties = response.data.properties;
                //         self.isUserLogged = response.data.isUserLogged;


                //     }).then(() => {
                //         self.initializeHomeContent();
                //     }).catch((err) => {

                //     });;


                // } catch (err) {
                //     this.error = err.response?.data?.message || "Login failed. Please try again.";
                // } finally {
                //     this.loading = false;
                // }
            },

         


        }
    }





</script>